import request from '@/utils/request'

/**
 * 查询拼团批次列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryGroupBuyBatch(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy/queryGroupBuyBatch',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}